const cards = [
  {
    title: '某顶流男星出轨实锤：时间线完整梳理与证据链分析',
    excerpt: '从深夜同框到酒店共度，历时三个月的跟踪调查揭示了一段不为人知的地下恋情。本文汇总了所有已曝光的照片、聊天记录与行程交叉验证。',
    date: '2026-07-28',
    tag: '深度解析',
    readTime: '12分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20style%20night%20photography%20with%20blurred%20city%20lights%2C%20luxury%20hotel%20entrance%20at%20night%2C%20warm%20amber%20street%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20tabloid%20aesthetic%2C%20cinematic%20composition%2C%20deep%20shadows&width=600&height=400&seq=card-01-2026&orientation=landscape',
  },
  {
    title: '知名女星婚变升级：财产分割内幕与抚养权争夺战',
    excerpt: '从甜蜜恩爱到对簿公堂，这场轰动娱乐圈的离婚案背后隐藏着巨额财产纠纷与子女抚养权的激烈争夺。',
    date: '2026-07-27',
    tag: '独家追踪',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20courtroom%20with%20dramatic%20lighting%2C%20legal%20documents%20on%20wooden%20table%2C%20warm%20dark%20tones%2C%20gavel%20in%20spotlight%2C%20editorial%20photography%2C%20serious%20atmosphere%2C%20high%20contrast&width=600&height=400&seq=card-02-2026&orientation=landscape',
  },
  {
    title: '综艺节目暗箱操作揭秘：选手排名背后的资本博弈',
    excerpt: '多位业内人士匿名爆料，揭露热门综艺节目中不为人知的暗箱操作，从选手内定到投票造假。',
    date: '2026-07-26',
    tag: '内幕曝光',
    readTime: '15分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20behind%20the%20scenes%20with%20dramatic%20spotlight%2C%20stage%20equipment%20and%20cables%2C%20warm%20production%20lighting%2C%20mysterious%20backstage%20atmosphere%2C%20editorial%20style%2C%20cinematic%20composition&width=600&height=400&seq=card-03-2026&orientation=landscape',
  },
  {
    title: '当红小生人设崩塌：从流量巅峰到全网抵制的72小时',
    excerpt: '一次酒后直播引发的连锁反应，将一位精心打造的人设艺人在短短三天内从神坛拉下，中间发生了什么？',
    date: '2026-07-25',
    tag: '时间线',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20social%20media%20trending%20topics%20with%20dramatic%20red%20glow%2C%20dark%20room%20atmosphere%2C%20digital%20age%20aesthetic%2C%20warm%20screen%20light%20on%20face%2C%20editorial%20photography%2C%20tense%20mood&width=600&height=400&seq=card-04-2026&orientation=landscape',
  },
  {
    title: '选秀节目导师私下索贿：聊天记录完整流出',
    excerpt: '一份神秘的微信聊天截图引发轩然大波，揭示了选秀节目背后令人震惊的利益输送链条。',
    date: '2026-07-24',
    tag: '实锤证据',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Closeup%20of%20smartphone%20chat%20screen%20with%20blurred%20text%20messages%2C%20dark%20ambient%20lighting%2C%20warm%20screen%20glow%2C%20mysterious%20atmosphere%2C%20digital%20privacy%20theme%2C%20editorial%20style%2C%20high%20contrast&width=600&height=400&seq=card-05-2026&orientation=landscape',
  },
  {
    title: '老牌歌手偷税漏税案尘埃落定：处罚细节与行业震动',
    excerpt: '历经两年调查，这起引发娱乐圈大地震的税务案件终于有了最终结果，由此引发的行业自查仍在继续。',
    date: '2026-07-23',
    tag: '案件追踪',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Official%20government%20building%20with%20columns%20at%20dusk%2C%20warm%20evening%20light%2C%20formal%20and%20serious%20atmosphere%2C%20document%20stack%20on%20desk%2C%20editorial%20photography%2C%20dramatic%20sky%2C%20authoritative%20mood&width=600&height=400&seq=card-06-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            深度解析
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            不止于吃瓜，更带你读懂娱乐圈背后的故事与逻辑
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <article key={i} className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer">
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  title={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-1 bg-primary-500 text-background-50 text-[10px] font-semibold rounded whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors mb-3">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 mb-4">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span><i className="ri-calendar-line mr-1"></i>{card.date}</span>
                  <span><i className="ri-time-line mr-1"></i>阅读 {card.readTime}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}